module.exports = __webpack_public_path__ + "static/img/76.9d391cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/76.png
// module id = vrwl
// module chunks = 0